import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { IconBigMediumPfeilRechts, IconComponent } from '@big-direkt/utils/icons';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-card-link',
    imports: [CommonModule, IconComponent, TranslocoDirective, UiLinkComponent],
    templateUrl: './card-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLinkComponent {
    public readonly iconArrowRight = IconBigMediumPfeilRechts;

    public readonly link = input.required<
        | {
            title?: string;
            href: string;
        }
        | undefined
    >();

    public readonly hideLink = input(false);
    public readonly customLinkClass = input<string>('text-primary dark:text-white');
    public readonly alignment = input<'left' | 'right'>('right');
}
